<template>
  <div class="main-content">
    <div class="main-wrap">
      <el-form ref="form" class="job-edit-form" :model="form" :rules="rules" label-width="100px">
        <div class="step-info">
          <span class="step-num">1</span>
          职位基本信息
        </div>
        <el-form-item label="职位名称：" prop="jobName">
          <el-input v-model="form.jobName" placeholder="请输入职位名称，如产品经理"></el-input>
        </el-form-item>
        <el-form-item label="工作性质：" prop="jobNatureId">
          <el-radio-group v-model="form.jobNatureId">
            <el-radio v-for="(item) in jobNatures" :key="item.value" :label="'' + item.value">{{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="form.jobNatureId!=12" label="职位类别：" prop="position">
          <el-cascader v-model="form.position" :options="positions" :props="positionProps" :show-all-levels="false"
            placeholder="选择职位类别" class="width_full" @change="onPositionChange">
          </el-cascader>
        </el-form-item>
        <el-form-item v-else label="职位类型：" prop="positionFlexId">
          <el-select v-model="form.positionFlexId" placeholder="请选择职位类型">
            <el-option v-for="item in postionFlexColumns" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="工作城市：" prop="city">
          <el-cascader class="width_full" v-model="form.city" :options="citys" @change="onCityChange"></el-cascader>
        </el-form-item>
        <el-form-item v-if="form.jobNatureId==12" label="工作地点：" prop="workAddrTypeId">
          <el-radio-group v-model="form.workAddrTypeId">
            <el-radio v-for="(item) in workAddrTypes" :key="item.workAddrTypeId" :label="item.workAddrTypeId">
              {{ item.text }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="(form.jobNatureId==12?'公司':'工作')+'地址：'" prop="workAddress">
          <el-input v-model="form.workAddress" placeholder="请输入详细地址"></el-input>
        </el-form-item>
        <el-form-item label="职位诱惑：" prop="jobAdvantage">
          <el-input v-model="form.jobAdvantage" placeholder="一句话说明职位优势"></el-input>
        </el-form-item>

        <div class="step-info" style="margin-top:34px">
          <span class="step-num">2</span>
          职位要求
        </div>
        <el-form-item v-if="form.jobNatureId==12" label="雇用类型：" prop="fhTypeId">
          <el-radio-group v-model="form.fhTypeId">
            <el-radio v-for="(item) in fhTypes" :key="item.fhTypeId" :label="item.fhTypeId">{{ item.text }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.jobNatureId==12" label="雇用时间：" prop="hireDates">
          <el-date-picker v-model="hireDates" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker> (共{{getDays()}}天)
        </el-form-item>
        <el-form-item label="工作经验：" prop="workExp">
          <el-select v-model="form.workExp" style="width: 436px;">
            <el-option v-for="item in postExperiences" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学历要求：" prop="degree">
          <el-select v-model="form.degree" style="width: 436px;">
            <el-option v-for="item in degrees" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="form.jobNatureId==12" label="薪酬类型：" prop="salaryTypeId">
          <el-radio-group v-model="form.salaryTypeId">
            <el-radio v-for="(item) in salaryTypes" :key="item.salaryTypeId" :label="item.salaryTypeId">{{ item.text }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.jobNatureId==12 && form.salaryTypeId==2" label="日薪范围：" prop="maxFlex2Salary">
          <el-select v-model="form.minFlex2Salary" placeholder="最低" @change="onMinDaySalaryChange">
            <el-option v-for="item in minDaySalarys" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="form.maxFlex2Salary" v-show="maxDaySalaryShow" placeholder="最高">
            <el-option v-for="item in maxDaySalarys" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-else label="月薪范围：" prop="maxSalary">
          <el-select v-model="form.minSalary" placeholder="最低" @change="onMinSalaryChange">
            <el-option v-for="item in minSalarys" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="form.maxSalary" v-show="maxSalaryShow" placeholder="最高">
            <el-option v-for="item in maxSalarys" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="职位描述：" prop="jobDescription">
          <el-input v-model="form.jobDescription" type="textarea" rows="5" placeholder="请输入岗位职责、任职要求等"></el-input>
        </el-form-item>
        <el-form-item>
          <div class="help-text">
            <p style="line-height: 28px"><i class="el-icon-info"></i><span style="margin-left:6px;">发布和编辑职位会扣除一个职位数</span></p>
            <p style="line-height: 28px"><i class="el-icon-info"></i><span style="margin-left:6px;">职位有效期 6 个月</span></p>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSave">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import {
    degreeList,
    jobNatureList,
    postExperienceList,
    postionFlexColumnsList
  } from '~/static/basicData';
  import cityList from '~/static/citys';

  import {
    getPositionList
  } from '~/api/common';

  import {
    jobEdit,
    getJobInfo
  } from '~/api/job';

  export default {
    data() {
      var greaterZero = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请选择一个选项'));
        } else {
          callback();
        }
      };
      return {
        jobId: this.$route.query.id,
        jobNatures: jobNatureList,
        positions: [],
        positionProps: {
          value: 'id',
          label: 'text',
          children: 'child'
        },
        minSalarys: [],
        maxSalarys: [],
        maxSalaryShow: false,
        citys: cityList.data,
        degrees: degreeList,
        postExperiences: postExperienceList,
        //灵活用工职位类型 0(129)：人事
        postionFlexColumns: postionFlexColumnsList,
        fhTypes: [{
          fhTypeId: 1,
          text: '分享雇用'
        }, {
          fhTypeId: 2,
          text: '独占雇用'
        }],
        hireDates: [],
        salaryTypes: [{
          salaryTypeId: 1,
          text: '月薪'
        }, {
          salaryTypeId: 2,
          text: '日薪'
        }],
        minDaySalarys: [],
        maxDaySalarys: [],
        maxDaySalaryShow: false,
        workAddrTypes: [{
          workAddrTypeId: 1,
          text: '不限'
        }, {
          workAddrTypeId: 2,
          text: '居家'
        }, {
          workAddrTypeId: 3,
          text: '公司'
        }],
        form: {
          jobName: '',
          position: '',
          positionId: 0,
          jobNatureId: 0,
          minSalary: '',
          maxSalary: '',
          city: '',
          cityId: '',
          workAddress: '',
          workExp: '',
          degree: '',
          jobAdvantage: '',
          jobDescription: '',

          //灵活职位信息：
          positionFlexId: '', //职位类型
          fhTypeId: '', //雇用类型
          useTypeId: 0,
          startDate: '', //雇用开始时间
          endDate: '', //雇用结束时间
          salaryTypeId: '', //薪酬类型
          // minFlex1Salary:0,//月薪 用 minSalary
          // maxFlex1Salary:0,
          minFlex2Salary: '', //日薪
          maxFlex2Salary: '',
          workAddrTypeId: '', //工作地点
        },
        rules: {
          jobName: [{
            required: true,
            message: '请输入职位名称',
            trigger: 'blur'
          }],
          position: [{
            required: true,
            message: '选择职位类别',
            trigger: 'change'
          }],
          fhTypeId: [{
            required: true,
            message: '选择雇用类别',
            trigger: 'change'
          }],
          positionFlexId: [{
            required: true,
            message: '选择职位类型',
            trigger: 'change'
          }],
          jobNatureId: [{
            required: true,
            validator: greaterZero,
            message: '选择工作性质',
            trigger: 'change'
          }],
          city: [{
            required: true,
            message: '选择工作城市',
            trigger: 'change'
          }],
          workAddress: [{
            required: true,
            message: '请输入详细地址',
            trigger: 'blur'
          }],
          jobAdvantage: [{
            required: true,
            message: '请输入职位优势',
            trigger: 'blur'
          }],
          workExp: [{
            required: true,
            message: '请选择工作经验',
            trigger: 'change'
          }],
          degree: [{
            required: true,
            message: '请选择学历要求',
            trigger: 'change'
          }],
          maxSalary: [{
            required: true,
            message: '请选择月薪范围',
            trigger: 'change'
          }],
          maxFlex2Salary: [{
            required: true,
            message: '请选择日薪范围',
            trigger: 'change'
          }],
          jobDescription: [{
            required: true,
            message: '请输入职位描述',
            trigger: 'blur'
          }],
          workAddrTypeId: [{
            required: true,
            message: '请选择工作地点',
            trigger: 'change'
          }],
          salaryTypeId: [{
            required: true,
            message: '请选择薪酬类型',
            trigger: 'change'
          }],
          hireDates: [{
            required: true,
            validator: (rule, value, callback) => {
              console.log(this.hireDates);
              if (this.hireDates.length == 0) callback(new Error('请选择雇用时间'));
              else callback();
            },
            trigger: 'change'
          }],
        }
      };
    },
    created() {
      this.getPositionList();
      this.initMinSalarys();
      if (this.jobId) {
        this.getJobInfo(this.jobId);
      }
      for (let salary = 100; salary <= 2000; salary += 100) {
        this.minDaySalarys.push({
          label: salary + '元',
          value: salary
        });
      }
    },
    methods: {
      getDays() {
        let s1 = new Date(this.hireDates[0]);
        let s2 = new Date(this.hireDates[1]);
        // console.log(this.hireDates)
        // let s1=this.hireDates[0];
        // let s2=this.hireDates[1];
        let times = s2.getTime() - s1.getTime();
        let days = parseInt(times / (1000 * 60 * 60 * 24));
        return isNaN(days) ? 0 : days + 1;
      },
      getPositionList() {
        getPositionList().then(m => {
          if (m.errcode == 0) {
            this.positions = m.data;
          }
        });
      },
      onPositionChange(value) {
        if (Array.isArray(value) && value.length == 2) {
          this.form.positionId = value[1];
        }
      },
      onCityChange(value) {
        if (Array.isArray(value) && value.length == 3) {
          this.form.cityId = value[2];
        }
      },
      initMinSalarys() {
        this.minSalarys = [];
        for (var i = 1; i <= 45; i++) {
          this.minSalarys.push({
            label: i + 'K',
            value: i
          });
        }
      },
      buildMaxSalarys(val) {
        this.maxSalarys = [];
        for (var i = 1; i < 6; i++) {
          var n = val + i;
          this.maxSalarys.push({
            label: n + 'K',
            value: n
          });
        }
      },
      onMinSalaryChange(val) {
        if (val) {
          this.maxSalaryShow = true;
          this.buildMaxSalarys(val);
        }
      },
      buildMaxDaySalarys(val) {
        this.maxDaySalarys = [];
        for (var i = 100; i < 600; i += 100) {
          var n = val + i;
          this.maxDaySalarys.push({
            label: n + '元',
            value: n
          });
        }
      },
      onMinDaySalaryChange(val) {
        if (val) {
          this.maxDaySalaryShow = true;
          this.buildMaxDaySalarys(val);
        }
      },
      getJobInfo(jobId) {
        var params = {
          job_id: jobId
        };
        getJobInfo(params).then(m => {
          if (m.errcode === 0) {
            var info = m.data;
            this.form.jobName = info.job_name;
            if (info.position_id) {
              this.form.positionId = info.position_id;
              this.form.position = [parseInt(info.position_id / 100) * 100, info.position_id];
            }
            this.form.jobNatureId = info.job_nature_id + '';
            if (info.min_salary) {
              this.form.minSalary = info.min_salary;
              this.buildMaxSalarys(info.min_salary);
            }
            if (info.max_salary) {
              this.form.maxSalary = info.max_salary;
              this.maxSalaryShow = true;
            }
            if (info.work_city_id) {
              this.form.cityId = info.work_city_id;
              this.form.city = [parseInt(info.work_city_id / 10000) * 10000, parseInt(info.work_city_id / 100) *
                100, info.work_city_id
              ];
            }
            this.form.workAddress = info.address;
            this.form.degree = info.degree_id ? info.degree_id : '';
            this.form.workExp = info.work_exp_id ? info.work_exp_id : '';
            this.form.jobAdvantage = info.post_advantage;
            this.form.jobDescription = info.description;

            let fp = info.flexible_info;
            this.form.positionFlexId = fp.PostTypeID; //类型
            this.form.fhTypeId = fp.HireTypeID; //雇佣类型
            this.form.useTypeId = fp.UsePeopleTypeID; //用工类型

            let st = fp.HireStartDate.substring(0, 10); //雇用开始日期
            if (st == '1900-01-01') this.form.startDate = '';
            else this.form.startDate = this.$Shared.formatDate(st);
            let et = fp.HireEndDate.substring(0, 10); //雇用结束日期
            if (et == '1900-01-01') this.form.endDate = '';
            else this.form.endDate = this.$Shared.formatDate(et);
            if (st > '1900' && et > '1900') {
              this.hireDates = [st, et];
            }

            this.form.salaryTypeId = fp.SalaryTypeID; //薪酬类型
            if (this.form.salaryTypeId == 1) {
              this.form.minSalary = fp.MinSalary;
              this.form.maxSalary = fp.MaxSalary;
              this.maSalaryShow = true;
            } else {
              this.form.minFlex2Salary = fp.MinSalary;
              this.form.maxFlex2Salary = fp.MaxSalary;
              this.buildMaxDaySalarys(fp.MinSalary);
              this.maxDaySalaryShow = true;
            }
            this.form.workAddrTypeId = fp.WorkAddressTypeID; //工作地点
          } else {
            this.$message.error('获取职位信息出错，原因：' + m.errmsg);
          }
        });
      },
      onSave() {
        this.$refs['form'].validate((valid) => {
          if (!valid) return false;
          var params = {
            job_id: this.jobId,
            job_name: this.form.jobName,
            position_id: this.form.positionId,
            job_nature_id: this.form.jobNatureId,
            min_salary: this.form.minSalary,
            max_salary: this.form.maxSalary,
            city_id: this.form.cityId,
            address: this.form.workAddress,
            degree_id: this.form.degree,
            work_exp_id: this.form.workExp,
            post_advantage: this.form.jobAdvantage,
            description: this.form.jobDescription,

            fh_post: { //以下为灵活雇用职位字段
              position_flex_id: this.form.positionFlexId, //类型
              hire_type_id: this.form.fhTypeId, //雇佣类型
              use_type_id: this.form.useTypeId, //用工类型
              start_date: this.hireDates[0], //雇用开始日期
              end_date: this.hireDates[1], //雇用结束日期
              salary_type: this.form.salaryTypeId, //薪酬类型
              min_salary: this.form.salaryTypeId == 1 ? this.form.minSalary : this.form.minFlex2Salary,
              max_salary: this.form.salaryTypeId == 1 ? this.form.maxSalary : this.form.maxFlex2Salary,
              work_addr_id: this.form.workAddrTypeId, //工作地点
            }
          };
          // console.log(params);
          // return;
          jobEdit(params).then(m => {
            if (m.errcode === 0) {
              this.$router.push('/JobIndex');
            } else {
              this.$message.error(m.errmsg);
            }
          });
        });
      }
    }
  };
</script>

<style>

</style>